// src/components/NotificationMarquee.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/NotificationMarquee.scss';

const NotificationMarquee = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleNotificationClick = () => {
        navigate('/admission');
    };

    return (
        <div className="notification-marquee" onClick={handleNotificationClick} style={{ cursor: 'pointer' }}>
            <div className="marquee-container">
                <div className="marquee-text">
                    {t('marquee_announcement')}
                </div>
            </div>
        </div>
    );
};

export default NotificationMarquee;
